import { Connect, PropComponents, BaseComponents, Utils, Constants } from './components/DmpChartDev'
import { getVueComponent, convertToVueComponent } from './getComponent'

const MobileSDK = window.f2 && window.f2._name !== 'noop' ? require('@views/dataview-mobile/sdk').default : null

export {
  Connect,
  PropComponents,
  BaseComponents,
  Utils,
  Constants,

  getVueComponent,
  convertToVueComponent,
  MobileSDK,
}
